import { lazyModulePage } from '@/soluqr/tiers/lazyModulePage';

export const dashboardRouteElements = [
  {
    segment: '',
    element: lazyModulePage('dashboard', () => import('@/soluqr/modules/dashboard/screens/DashboardPage')),
  },
];
